__turbopack_context__.v({
  "className": "_42ewiG_className",
  "variable": "_42ewiG_variable",
});
